<template>
	<VDialogV3
		id="characteristic-group-card"
		position="right"
		width="600px"
		height="100vh"
		:loading="localGroup == null"
    :title="localGroup?.toString()"

    :context-menu="editMode ? CharacteristicGroupsService.contextMenu : null"
    :entity="localGroup"

		:submit-disabled="isSaveDisabled"

		@submit="onSubmit"
	>
		<section>
			<article>
				<VInput
					ref="nameInput"
					v-model="localGroup.name"
					label="Название группы характеристик"
					layout="vertical"
					required
					:validate-method="validateName"
				/>
			</article>
		</section>
	</VDialogV3>
</template>

<script lang="ts">

import CharacteristicGroup            from '@/domains/CharacteristicGroups/CharacteristicGroup';
import CharacteristicGroupsService    from '@/domains/CharacteristicGroups/CharacteristicGroupsService';

export default defineComponent({
	name: 'CharacteristicGroupCard',

	props: {
		/** Готовый объект — передаётся из реестра */
		entity: {
			type:    CharacteristicGroup,
			default: null,
		},
		/** ID — карточка сама загружает объект */
		id: {
			type:    Number,
			default: null,
		},
	},

  setup() {
    return {
      CharacteristicGroupsService
    }
  },

	data() {
		return {
			localGroup: null as CharacteristicGroup | null,
		};
	},

	computed: {
		editMode(): boolean {
			return this.localGroup?.id != null;
		},

		isSaveDisabled(): boolean {
			return !this.localGroup?.name;
		},
	},

	async mounted() {
		await this.init();
	},

	methods: {
		async init(): Promise<void> {
			if (this.id) {
				this.localGroup = await CharacteristicGroupsService.get(this.id);
			} else if (this.entity instanceof CharacteristicGroup) {
				this.localGroup = this.$core.utils.cloneDeep(this.entity);
			} else {
				this.localGroup = new CharacteristicGroup();
			}
		},

		async validateName(value: string): Promise<string | null> {
			if (typeof value !== 'string' || value.length === 0) return null;
			if (value.length > 200) return 'Максимальная длина поля 200 символов';
			return null;
		},

		async onSubmit(): Promise<void> {
			if (!this.localGroup) return;

			const success = this.editMode
				? await CharacteristicGroupsService.update(this.localGroup)
				: await CharacteristicGroupsService.add(this.localGroup);

			if (success) {
				this.$core.dialogs.CharacteristicGroupCard.resolve();
			}
		},

	},
});
</script>
